"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconError = void 0;
var React = __importStar(require("react"));
var IconError = function (props) { return (React.createElement("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 24 24" }, props),
    React.createElement("g", { id: "Informative/ic_error", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M12,21 C16.962,21 21,16.963 21,12 C21,7.037 16.962,3 12,3 C7.038,3 3,7.037 3,12 C3,16.963 7.038,21 12,21 Z M12,2 C17.514,2 22,6.486 22,12 C22,17.514 17.514,22 12,22 C6.486,22 2,17.514 2,12 C2,6.486 6.486,2 12,2 Z M16.8535,7.1445 C17.0485,7.3395 17.0485,7.6565 16.8535,7.8515 L12.7075,11.9985 L16.8535,16.1445 C17.0485,16.3395 17.0485,16.6565 16.8535,16.8515 C16.7555,16.9495 16.6275,16.9985 16.4995,16.9985 C16.3725,16.9985 16.2445,16.9495 16.1465,16.8515 L11.9995,12.7055 L7.8535,16.8515 C7.7555,16.9495 7.6275,16.9985 7.4995,16.9985 C7.3725,16.9985 7.2445,16.9495 7.1465,16.8515 C6.9515,16.6565 6.9515,16.3395 7.1465,16.1445 L11.2925,11.9985 L7.1465,7.8515 C6.9515,7.6565 6.9515,7.3395 7.1465,7.1445 C7.3415,6.9495 7.6585,6.9495 7.8535,7.1445 L11.9995,11.2905 L16.1465,7.1445 C16.3415,6.9495 16.6585,6.9495 16.8535,7.1445 Z", id: "error", fill: "#464650" }),
        React.createElement("rect", { id: "Padding", x: 0, y: 0, width: 24, height: 24 })))); };
exports.IconError = IconError;
exports.IconError.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconError;
